import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full py-8 md:py-14 px-4 md:px-6 lg:px-8">
      <div className="w-full">
        {/* Header */}
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="font-heading font-bold text-xl md:text-2xl text-background-50">
              Shop by Category
            </h2>
            <p className="text-sm text-background-200 mt-1">
              Browse our wide range of product categories
            </p>
          </div>
          <a
            href="/categories"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-semibold text-background-50 hover:text-background-200 transition-colors whitespace-nowrap"
          >
            All Categories
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3 md:gap-4 lg:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={`/shop/${cat.slug}`}
              className="group flex flex-col items-center text-center p-3 md:p-4 rounded-xl md:rounded-2xl bg-background-50 border border-background-200/60 hover:border-primary-300 hover:shadow-md hover:shadow-primary-100/50 transition-all duration-300"
            >
              <div className="w-12 h-12 md:w-16 md:h-16 rounded-xl md:rounded-2xl bg-primary-50 group-hover:bg-primary-100 flex items-center justify-center mb-2 md:mb-3 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-500 group-hover:text-primary-600 transition-colors`} />
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors leading-tight">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}